export default function(state = [], action) {
  switch (action.type) {
    case "SYSTEM_TPP_SELECTED_FILTERS":
      return action.payload;

    default:
      return state;
  }
}
